import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { getAssetUrl } from "../../utils/url";

@customElement("bp-logo")
export class Logo extends LitElement {
  static styles = css`
    :host {
      --height: var(--logo-height, 36px);

      display: inline-flex;
    }

    img {
      display: block;
    }
  `;

  @property()
  title: string = "BibleProject Logo";

  @property()
  variant: "default" | "mark" | "en" | "es" = "default";

  get src() {
    // Use as "default" and "en"
    let logoSrc = getAssetUrl("/bibleproject.svg");

    switch (this.variant) {
      case "es":
        logoSrc =
          "https://ik.imagekit.io/bpweb1/web/media/Brand/logo-proyecto-biblia-1.png?tr=q-100";
        break;
      case "mark":
        logoSrc = getAssetUrl("/bibleproject-mark.svg");
        break;
    }

    return logoSrc;
  }

  render() {
    return html`
      <img
        src="${this.src}"
        style="height: var(--height);"
        title="${this.title}"
      />
    `;
  }
}
